module.exports = __webpack_public_path__ + "img/icons B_21.b35cc548.png";